import React, { useEffect, useState } from "react";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
import "react-tree-graph/dist/style.css";
import { toastAlert } from "../helper/toastAlert.js";
import { useParams } from "react-router-dom";
import config from '../config/config'
import { connection } from "../helper/connection.js";
import ZolttanABI from '../ABI/ZolttanABI.json'
import { getrecords, get_emergencydistributedetails , get_royaldistributedetails ,get_distributedetails, updateglobaldistribute , updateroyaldistribute , canceldistribute } from "../Action/apiAction";
import moment from 'moment';
import Countdown, { zeroPad } from "react-countdown";
import { convert } from "../helper/convert.js";
import { type WalletClient, useWalletClient } from 'wagmi';
import Web3 from "web3";
// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function Setting(props) {
    var { id } = useParams();
    const [progress, setprogress] = useState("false");
    const [progress1, setprogress1] = useState("false");
    const [autoprogress, setautoprogress] = useState("false");
    const [withdrawprogress, setwithdrawprogress] = useState("false");
    const [countprogress, setcountprogress] = useState("false");
    const [inputaddress, setinputaddress] = useState("");
    const [amount, setamount] = useState("");
    const [globalcount, setglobalcount] = useState(0);
    const [royalcount, setroyalcount] = useState(0);
    const [totaluser,settotaluser] =useState(0);
    const [globalrecords, setglobalrecords]=useState([]);
    const [royalrecords, setroyalrecords]=useState([]);
    const [lastrewardtime,setlastrewardtime] = useState("");
    const [emer_progress,setemer_progress] = useState("false");
    const [royprogress,setroyprogress] = useState("false");
    const [roy1progress,setroy1progress] = useState("false");
    const [inputroyaddress,setinputroyaddress] = useState("");
    const [inputroy1address,setinputroy1address] = useState("");
    const [removeroy,setremoveroy] = useState("");
    const [removeroy1,setremoveroy1] = useState("");
    const [reroyprogress,setreroyprogress] = useState("false");
    const [reroy1progress,setreroy1progress] = useState("false");
    let chainid = config.NetworkId ;
    const { data: walletClient } = useWalletClient({ chainid })
  
    useEffect(() => {
      getdetails();
      getrec();
    }, [walletClient]);
  
    async function getrec() {
      let datas = await getrecords();
      if (datas && datas.data && datas.data.data) {
        setglobalrecords(datas.data.data);
        setroyalrecords(datas.data.data1)
        setglobalcount(datas.data.globalcount);
      }
    }
  
    async function getdetails() {
        var get = await connection();
        if(get && get.web3){
            var web3 = new Web3(get.web3)
            var zolttancontract = new web3.eth.Contract(ZolttanABI, config.ZolttanAddress);
            let lasttimestamp = await zolttancontract.methods.lastRewardTimestamp().call();
            lasttimestamp = moment.unix(lasttimestamp).toDate();
            lasttimestamp = moment(lasttimestamp).add(7, 'days');
            setlastrewardtime(lasttimestamp);
            let countsuser = await zolttancontract.methods.getRoyalparticipantsLength().call();
            setroyalcount(countsuser)
        }
        else{

        }
   
    }
  
    async function empty() {
  
    }

    const addressroyremovechange = (e) => {
      setremoveroy(e.target.value);
    }

    const addressroy1removechange = (e) => {
      setremoveroy1(e.target.value);
    }
  
    const addresschange = (e) => {
      setinputaddress(e.target.value);
    }
  
    const amountchange = (e) => {
      setamount(e.target.value);
    }
  
    const countchange = (e) => {
      setcount(e.target.value);
    }

    const addressroychange = (e) =>{
      setinputroyaddress(e.target.value)
    }

    const addressroy1change = (e) =>{
      setinputroy1address(e.target.value)
    }
  
    async function emergency(){
      setemer_progress("true");
      await get_emergencydistributedetails();
      await getrec();
      setemer_progress("false");
    }

    async function submitroyal(num) {
      try {
        setprogress1("true")
        var get = await connection();
        if(get && get.web3){
          let web3 = new Web3(get.web3)
          let address = get.address
          var ZolttanContract = new web3.eth.Contract(ZolttanABI, config.ZolttanAddress);
          let owneraddress = await ZolttanContract.methods.owner().call();
          if ((owneraddress).toLowerCase() == (address).toLowerCase()) {
            let datass = {
              "skip": num == 1 ? 0 : num == 2 ? 500 : num ==3 ? 1000 :  num ==4 ? 1500 : 2000,
              "limit": num == 1 ? 500 : num == 2 ? 1000 : num ==3 ? 1500 :  num ==4 ? 2000 : 2500
            }
            let distribut_details = await get_royaldistributedetails(datass);
            console.log(distribut_details.data.address.length,distribut_details.data.address,distribut_details.data.g1amaount)
            let register = await ZolttanContract.methods.teamRoyalitydistributionNew(distribut_details.data.address,distribut_details.data.g1amaount).send({
              from: address
            })
            if (register && register.status && register.transactionHash) {
              await updateroyaldistribute();
              setprogress1("false")
              toastAlert('success', "Distributed Successfully", 'network');
              window.location.reload();
            } else {
              await canceldistribute();
              setprogress1("false")
              toastAlert('success', "Failed , try again later", 'network');
            }
         } else {
            setprogress1("false")
            toastAlert('error', "Login into Admin Address", 'network');
          }
  
        } else {
          setprogress1("false")
          toastAlert('error', "Please select BSC chain network", 'network');
        }
      } catch (err) {
        console.log(err,"=====err")
        await canceldistribute();
        setprogress1("false")
      }
    }
  
    async function submitglobal(num) {
      try {
        setprogress("true")
        var get = await connection();
        if(get && get.web3){
          let web3 = new Web3(get.web3)
          let address = get.address
          var ZolttanContract = new web3.eth.Contract(ZolttanABI, config.ZolttanAddress);
          let owneraddress = await ZolttanContract.methods.owner().call();
          if ((owneraddress).toLowerCase() == (address).toLowerCase()) {
            let datass = {
              "skip": num == 1 ? 0 : num == 2 ? 500 : num ==3 ? 1000 :  num ==4 ? 1500 : 2000,
              "limit": num == 1 ? 500 : num == 2 ? 1000 : num ==3 ? 1500 :  num ==4 ? 2000 : 2500
            }
            let distribut_details = await get_distributedetails(datass);
            if(distribut_details && distribut_details.data && distribut_details.data.status && distribut_details.data.length>0 ){
              console.log(distribut_details.data.length,"1", distribut_details.data.address,"2", distribut_details.data.ramount,"3", distribut_details.data.g1amaount,"4","=5=======")
            let register = await ZolttanContract.methods.globalRoyalitydistribution( distribut_details.data.address,distribut_details.data.g1amaount).send({
              from: address
            })
            if (register && register.status && register.transactionHash) {
              await updateglobaldistribute();
              setprogress("false")
              toastAlert('success', "Distributed Successfully", 'network');
              window.location.reload();
            } else {
              await canceldistribute();
              setprogress("false")
              toastAlert('success', "Failed , try again later", 'network');
            }
        }else{
          setprogress("false")
          toastAlert('error', "Failed , try again later", 'network');
        }
         } else {
            setprogress("false")
            toastAlert('error', "Login into Admin Address", 'network');
          }
  
        } else {
          setprogress("false")
          toastAlert('error', "Please select BSC chain network", 'network');
        }
      } catch (err) {
        console.log(err,"=====err")
        await canceldistribute();
        setprogress("false")
      }
    }
  
    async function withdraw() {
      try {
        setwithdrawprogress("true")
        var get = await connection();
        if(get && get.web3){
          if (parseFloat(amount) > 0) {
            let web3 = new Web3(get.web3);
            let address = get.address
            if (web3.utils.isAddress(inputaddress)) {
              var ZolttanContract = new web3.eth.Contract(ZolttanABI, config.ZolttanAddress);
              let owneraddress = await ZolttanContract.methods.owner().call();
              if ((owneraddress).toLowerCase() == (address).toLowerCase()) {
                let withamt = parseFloat(amount) * 1e18
                let sendamt = await convert(withamt);
                let register = await ZolttanContract.methods.safeWithDrawbnb(sendamt.toString(), inputaddress).send({
                  from: address
                })
                if (register && register.status && register.transactionHash) {
                  setwithdrawprogress("false")
                  toastAlert('success', "Withdraw doned Successfully", 'network');
                  window.location.reload();
                } else {
                  setwithdrawprogress("false")
                  toastAlert('success', "Failed , try again later", 'network');
                }
              } else {
                setwithdrawprogress("false")
                toastAlert('error', "Login into Admin Address", 'network');
              }
            } else {
              setwithdrawprogress("false")
              toastAlert('error', "Enter Valid Address", 'network');
            }
          } else {
            setwithdrawprogress("false")
            toastAlert('error', "Enter Valid Amount", 'network');
          }
        } else {
          setwithdrawprogress("false")
          toastAlert('error', "Please select BSC chain network", 'network');
        }
      } catch (err) {
        setwithdrawprogress("false")
      }
    }
      
    const currentDate = new Date();
    const year = (currentDate.getMonth() === 11 && currentDate.getDate() > 23) ? currentDate.getFullYear() + 1 : currentDate.getFullYear();

    const renderer = ({ days, hours, minutes, seconds }) => {
      return (
        <div className="timer_panel">
          <span><span className="timer_time">{zeroPad(days)}</span><span className="timer_label">Days</span></span>
          <span className="timer_dots">:</span>
          <span><span className="timer_time">{zeroPad(hours)}</span><span className="timer_label">Hours</span></span>
          <span className="timer_dots">:</span>
          <span><span className="timer_time">{zeroPad(minutes)}</span><span className="timer_label">Mins</span></span>
          <span className="timer_dots">:</span>
          <span><span className="timer_time">{zeroPad(seconds)}</span><span className="timer_label">Secs</span></span>
        </div>
      );
    };
  
  return (
    <div>
      <ScrollToTopOnMount />
      <Navbar />
      <div className="inner_wrapper">
        <div className="container">
          <div className="dashboard_panel join_now_panel">
            <div className="row">
              <div className="col-md-12 col-lg-8 m-auto">
                <div className="title_flex">
                  <h2 className="inner_title">Settings</h2>
                  {/*<div className="row">
                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <div className="form-group row">
                          <div className="col-lg-12 text-start">
                            <label for="exampleFormControlInput1" class="form-label">Distribute Global Royalty</label>
                            <label for="exampleFormControlInput1" class="form-label">{"(Users Count:" + globalcount + " )"}</label>
                            <button type="button" className="primary_btn" onClick={progress == "false" ? () => submitglobal(1) : () => empty()} disabled={(progress == "true" || autoprogress == "true" || withdrawprogress == "true" || royprogress== "true" || roy1progress == "true" || reroyprogress == "true" || reroy1progress == "true" || countprogress == "true" || progress1 == "true") ? "disabled" : ""}>{progress == "false" ? "Distribute" : "Processing..Please Wait.."}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <p className="text-danger mb-1">If any emergency, You can distribute Here.</p>
                        {emer_progress=="true" && 
                          <p className="text-danger mb-1">Wait for 20 Minutes</p>
                        }
                        {emer_progress=="true"?
                          <button type="button" className="primary_btn">Please Wait..</button>
                          :
                          <button type="button" className="primary_btn" onClick={()=>emergency()}>Emergency Distribute</button>
                        }
                        <div className="timer"> 
                        {lastrewardtime!="" &&                        
                          <Countdown date={new Date(lastrewardtime)} 
                                  autoStart={true}
                                  onStart={() => new Date(lastrewardtime)} renderer={renderer} />  
                        }                       
                        </div>
                      </div>
                    </div>
                  </div>*/}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <div className="form-group row">
                          <div className="col-lg-12 text-start">
                            <label for="exampleFormControlInput1" class="form-label">Distribute Team Royalty</label>
                            <label for="exampleFormControlInput1" class="form-label">{"(Users Count:" + (royalrecords.length) + " )"}</label>
                            <button type="button" className="primary_btn" onClick={progress1 == "false" ? () => submitroyal(1) : () => empty()} disabled={(progress1 == "true" || autoprogress == "true" || withdrawprogress == "true" || royprogress== "true" || roy1progress == "true" || reroyprogress == "true" || reroy1progress == "true" || countprogress == "true" || progress == "true") ? "disabled" : ""}>{progress1 == "false" ? "Distribute" : "Processing..Please Wait.."}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                     <div className="col-md-6">
                      <div className="primary_box dash_box mt-4">
                        <div className="form-group row">
                          <div className="col-lg-12 text-start">
                            <label for="exampleFormControlInput1" class="form-label">Distribute Global Royalty</label>
                            <label for="exampleFormControlInput1" class="form-label">{"(Users Count:" + (globalrecords.length) + " )"}</label>
                            <button type="button" className="primary_btn" onClick={progress == "false" ? () => submitglobal(1) : () => empty()} disabled={(progress1 == "true" || autoprogress == "true" || withdrawprogress == "true" || royprogress== "true" || roy1progress == "true" || reroyprogress == "true" || reroy1progress == "true" || countprogress == "true" || progress == "true") ? "disabled" : ""}>{progress == "false" ? "Distribute" : "Processing..Please Wait.."}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="primary_box dash_box mt-4">
                        <div className="form-group row">
                          <div className="col-lg-12 text-start">
                            <label for="exampleFormControlInput1" class="form-label">Safe Withdraw</label>
                            <input type="text" value={amount} class="form-control mb-3 primary_inp" id="exampleFormControlInput11" placeholder="Enter Amount BUSD" onChange={amountchange} />
                            <input type="text" value={inputaddress} class="form-control primary_inp" id="exampleFormControlInput11" placeholder="Enter Address" onChange={addresschange} />
                            <button type="button" className="primary_btn" onClick={withdrawprogress == "false" ? () => withdraw() : () => empty()} disabled={(progress == "true" || autoprogress == "true" || withdrawprogress == "true" || royprogress== "true" || roy1progress == "true" || reroyprogress == "true" || reroy1progress == "true" || countprogress == "true" || progress1 == "true") ? "disabled" : ""}>{withdrawprogress == "false" ? "Withdraw" : "Processing..Please Wait.."}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="primary_box dash_box mt-4">
                      <div className="dashbox_middle_bottom">
                        <h2>Global Royalty User List</h2>
                        <div className='plan_income_table_div'>
                          <div className='table-responsive'>
                            <table className='table plan_income_table mt-0'>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>UserId</th>
                                  <th>Address</th>
                                  <th>Global Royalty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {globalrecords && globalrecords.length > 0 && globalrecords.map((item, index) => {
                                  return (
                                    <tr>
                                      <td>{parseInt(index) + 1}</td>
                                      <td>{item.userid}</td>
                                      <td>{item.address}</td>
                                      <td>{((Math.round(item.globalroyality_A)) / 1000000000000000000).toFixed(4)}</td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="primary_box dash_box mt-4">
                      <div className="dashbox_middle_bottom">
                        <h2>Team Royalty User List</h2>
                        <div className='plan_income_table_div'>
                          <div className='table-responsive'>
                            <table className='table plan_income_table mt-0'>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>UserId</th>
                                  <th>Address</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {royalrecords && royalrecords.length > 0 && royalrecords.map((item, index) => {
                                  return (
                                    <tr>
                                      <td>{parseInt(index) + 1}</td>
                                      <td>{item.userid}</td>
                                      <td>{item.address}</td>
                                      <td>{(parseFloat(item.royality)/1e18).toFixed(4)}</td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
